@if (renderRegisterFormContent) {
<div class="form-container">
  <div class="text-center pt-5">
    <h1 class="fw-bold">Application Form: AIKosh</h1>
    <h1 class="fw-bold">University Engagement Programme</h1>
  </div>

  <div
    class="fw-400 text-sm text-center mb-4"
    [class.text-primary]="registrationWindowStatus === RegistrationWindowStatus.Open"
    [class.text-danger]="registrationWindowStatus !== RegistrationWindowStatus.Open"
  >
    {{ registrationWindowMessage }}
  </div>

  <form [formGroup]="applicationForm" (ngSubmit)="onSubmit()">
    <section class="form-section border rounded p-4">
      <h2 class="section-title">Expression of Interest</h2>

      <!-- ================= Part A ================= -->
      <div class="part-box mb-4 border rounded p-6">
        <h3 class="part-title">Part A : INSTITUTION DETAILS</h3>
        <p class="part-subtitle text-muted mb-4">
          Provide details about your Institution
        </p>

        <div class="row g-3">
          <div class="col-md-6">
            <app-text-input
              inputId="fullNameOfInstitution"
              [label]="
                formConfig['fullNameOfInstitution']?.label ||
                'Full Name of the Institution'
              "
              [isRequired]="true"
              [control]="$any(applicationForm.get('fullNameOfInstitution'))"
              [placeholder]="
                formConfig['fullNameOfInstitution']?.placeholder || ''
              "
              [noteText]="formConfig['fullNameOfInstitution']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label fw-medium mb-0">
                {{ formConfig["institutionType"]?.label }}
                <span class="text-danger">*</span>
              </label>

              <select
                formControlName="institutionType"
                class="form-select py-2 mt-2"
                style="
                  height: 54px;
                  min-height: 54px;
                  border: 1px solid #d1cfcf;
                  border-radius: 12px;
                "
                [style.fontSize]="
                  applicationForm.get('institutionType')?.value
                    ? '14px'
                    : '15px'
                "
                [style.color]="
                  applicationForm.get('institutionType')?.value
                    ? '#212529'
                    : '#6c757d'
                "
                [class.is-invalid]="isInvalid('institutionType')"
              >
                <option value="" disabled selected hidden>
                  {{ formConfig["institutionType"]?.placeholder }}
                </option>
                <option
                  *ngFor="let type of institutionTypes"
                  [value]="type"
                  style="font-size: 14px; color: #212529"
                >
                  {{ type }}
                </option>
              </select>

              <div
                class="text-danger text-xs mt-1"
                *ngIf="isInvalid('institutionType')"
              >
                {{ formConfig["institutionType"]?.errorMsg }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <app-text-input
              inputId="city"
              label="{{ formConfig['city']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('city'))"
              placeholder="{{ formConfig['city']?.placeholder }}"
              [noteText]="formConfig['city']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label fw-medium mb-0">
                {{ formConfig["state"]?.label }}
                <span class="text-danger">*</span>
              </label>
              <select
                formControlName="state"
                class="form-select py-2 mt-2"
                style="
                  height: 54px;
                  min-height: 54px;
                  border: 1px solid #d1cfcf;
                  border-radius: 12px;
                "
                [style.fontSize]="
                  applicationForm.get('state')?.value ? '14px' : '15px'
                "
                [style.color]="
                  applicationForm.get('state')?.value ? '#212529' : '#6c757d'
                "
                [class.is-invalid]="isInvalid('state')"
              >
                <option value="" disabled selected hidden>
                  {{ formConfig["state"]?.placeholder }}
                </option>
                <option
                  *ngFor="let state of states"
                  [value]="state"
                  style="font-size: 14px; color: #212529"
                >
                  {{ state }}
                </option>
              </select>

              <div class="text-danger text-xs mt-1" *ngIf="isInvalid('state')">
                {{ formConfig["state"]?.errorMsg }}
              </div>
            </div>
          </div>

          <div class="col-12">
            <app-text-input
              inputId="institutionWebsite"
              label="{{ formConfig['institutionWebsite']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('institutionWebsite'))"
              placeholder="{{ formConfig['institutionWebsite']?.placeholder }}"
              [noteText]="formConfig['institutionWebsite']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <div class="col-12">
            <app-text-input
              inputId="naacAccreditationGrade"
              label="{{ formConfig['naacAccreditationGrade']?.label }}"
              [control]="$any(applicationForm.get('naacAccreditationGrade'))"
              placeholder="{{
                formConfig['naacAccreditationGrade']?.placeholder
              }}"
              [maxLength]="200"
              [noteText]="formConfig['naacAccreditationGrade']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <label class="form-label fw-medium mb-0"></label>
            </div>
            <app-textarea-input
              inputId="previousEngagementWithIndiaAI"
              label="{{ formConfig['previousEngagementWithIndiaAI']?.label }}"
              [control]="
                $any(applicationForm.get('previousEngagementWithIndiaAI'))
              "
              [rows]="4"
              [maxLength]="2000"
              placeholder="{{
                formConfig['previousEngagementWithIndiaAI']?.infoText
              }}"
            >
            </app-textarea-input>
          </div>

          <!-- 3. NIRF ranking, if applicable (goes to Part A) -->
          <div class="col-12">
            <app-textarea-input
              inputId="nirfRanking"
              label="{{ formConfig['nirfRanking']?.label }}"
              [control]="$any(applicationForm.get('nirfRanking'))"
              [rows]="3"
              [maxLength]="500"
              placeholder="{{ formConfig['nirfRanking']?.infoText }}"
            >
            </app-textarea-input>
          </div>
        </div>
      </div>

      <!-- =================== Part B =================== -->
      <div class="part-box mb-4 border rounded p-6">
        <h3 class="part-title">Part B : ACADEMIC AND PROGRAMME FIT</h3>

        <div class="row g-3">
          <!-- 1. Participating Departments -->
          <div class="col-12">
            <app-textarea-input
              inputId="participatingDepartments"
              label="{{ formConfig['participatingDepartments']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('participatingDepartments'))"
              [rows]="4"
              [maxLength]="1500"
              placeholder="{{
                formConfig['participatingDepartments']?.infoText
              }}"
            >
            </app-textarea-input>
          </div>

          <!-- 2. Relevant AIKosh sectors -->
          <div class="col-12">
            <label class="form-label fw-medium mb-2">
              {{ formConfig["relevantSectors"]?.label }}
              <span class="text-danger">*</span>
            </label>

            <div [class.border-danger]="isInvalid('relevantSectors')">
              <div class="row g-2 p-4">
                <div
                  class="col-md-4 col-sm-6 col-6"
                  *ngFor="let sector of sectors"
                >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="sector"
                      [checked]="isSectorSelected(sector)"
                      (change)="onSectorChange(sector, $event)"
                    />
                    <label class="form-check-label g-2" [for]="sector">
                      {{ sector }}
                    </label>
                  </div>

                  <!-- Conditional input field displayed right below 'Others' when checked -->
                  <div
                    class="mt-2"
                    *ngIf="sector === 'Others' && isSectorSelected('Others')"
                  >
                    <app-text-input
                      inputId="otherSectorDetails"
                      label="{{ formConfig['otherSectorDetails']?.label }}"
                      [control]="
                        $any(applicationForm.get('otherSectorDetails'))
                      "
                         [isRequired]="true"
                      placeholder="{{
                        formConfig['otherSectorDetails']?.placeholder
                      }}"
                      [maxLength]="100"
                      [noteText]="
                        formConfig['otherSectorDetails']?.infoText || ''
                      "
                    >
                    </app-text-input>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 3. Sector Alignment Reasoning -->
          <div class="col-12">
            <app-textarea-input
              inputId="selectAllReasoning"
              label="{{ formConfig['selectAllReasoning']?.label }}"
              [control]="$any(applicationForm.get('selectAllReasoning'))"
              [rows]="4"
              [maxLength]="2000"
              placeholder="{{ formConfig['selectAllReasoning']?.infoText }}"
            >
            </app-textarea-input>
          </div>

          <!-- 4. AI and data relevance to departments -->
          <div class="col-12">
            <app-textarea-input
              inputId="aiDataRelevance"
              label="{{ formConfig['aiDataRelevance']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('aiDataRelevance'))"
              [rows]="4"
              [maxLength]="2500"
              placeholder="{{ formConfig['aiDataRelevance']?.infoText }}"
            >
            </app-textarea-input>
          </div>

          <!-- 5. Connection with existing coursework -->
          <div class="col-12">
            <app-textarea-input
              inputId="connectionWithExistingCoursework"
              label="{{
                formConfig['connectionWithExistingCoursework']?.label
              }}"
              [control]="
                $any(applicationForm.get('connectionWithExistingCoursework'))
              "
              [rows]="4"
              [maxLength]="2000"
              placeholder="{{
                formConfig['connectionWithExistingCoursework']?.infoText
              }}"
            >
            </app-textarea-input>
          </div>

          <!-- 6. Relevance of AIKosh sectors to participating departments (goes to Part B) -->
          <div class="col-12">
            <app-textarea-input
              inputId="sectorRelevanceReasoning"
              label="{{ formConfig['sectorRelevanceReasoning']?.label }}"
              [control]="$any(applicationForm.get('sectorRelevanceReasoning'))"
              [rows]="4"
              [maxLength]="200"
              placeholder="{{ formConfig['sectorRelevanceReasoning']?.infoText }}"
            >
            </app-textarea-input>
          </div>
        </div>
      </div>
      <!-- End Part B -->

      <!-- =================== Part C =================== -->
      <div class="part-box mb-4 border rounded p-6">
        <h3 class="part-title">
          Part C : CONTACT PERSON AND OPERATIONAL READINESS
        </h3>

        <div class="row g-3">
          <!-- 1. Full name of the contact person -->
          <div class="col-12">
            <app-text-input
              inputId="fullNameContactPerson"
              label="{{ formConfig['fullNameContactPerson']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('fullNameContactPerson'))"
              placeholder="{{
                formConfig['fullNameContactPerson']?.placeholder
              }}"
              [noteText]="formConfig['fullNameContactPerson']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <!-- 2. Designation -->
          <div class="col-md-6">
            <app-text-input
              inputId="designation"
              label="{{ formConfig['designation']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('designation'))"
              placeholder="{{ formConfig['designation']?.placeholder }}"
              [noteText]="formConfig['designation']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <!-- 3. Department -->
          <div class="col-md-6">
            <app-text-input
              inputId="department"
              label="{{ formConfig['department']?.label }}"
              [isRequired]="true"
              [control]="$any(applicationForm.get('department'))"
              placeholder="{{ formConfig['department']?.placeholder }}"
              [noteText]="formConfig['department']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <!-- 4. Official Email Address -->
          <div class="col-md-6">
            <app-text-input
              inputId="officialEmailAddress"
              label="{{ formConfig['officialEmailAddress']?.label }}"
              type="email"
              [isRequired]="true"
              [control]="$any(applicationForm.get('officialEmailAddress'))"
              placeholder="{{
                formConfig['officialEmailAddress']?.placeholder
              }}"
              [noteText]="formConfig['officialEmailAddress']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <!-- 5. Phone Number -->
          <div class="col-md-6">
            <app-text-input
              inputId="phoneNumber"
              label="{{ formConfig['phoneNumber']?.label }}"
              inputmode="tel"
              [isRequired]="true"
              [control]="$any(applicationForm.get('phoneNumber'))"
              placeholder="{{ formConfig['phoneNumber']?.placeholder }}"
              [noteText]="formConfig['phoneNumber']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <!-- 6. Suitability of contact person -->
          <div class="col-12">
            <app-textarea-input
              inputId="suitabilityOfContactPerson"
              label="{{ formConfig['suitabilityOfContactPerson']?.label }}"
              [maxLength]="2000"
              [rows]="4"
              [control]="
                $any(applicationForm.get('suitabilityOfContactPerson'))
              "
              placeholder="{{
                formConfig['suitabilityOfContactPerson']?.infoText
              }}"
            >
            </app-textarea-input>
          </div>

          <!-- 7. Faculty evaluator for Level B hackathon submissions (goes to Part C, optional) -->
          <div class="col-12">
            <app-textarea-input
              inputId="facultyEvaluatorDetails"
              label="{{ formConfig['facultyEvaluatorDetails']?.label }}"
              [control]="$any(applicationForm.get('facultyEvaluatorDetails'))"
              [rows]="4"
              [maxLength]="2000"
              placeholder="{{ formConfig['facultyEvaluatorDetails']?.infoText }}"
            >
            </app-textarea-input>
          </div>

          <!-- 8. Alternate operational coordinator details (goes to Part C, optional) -->
          <div class="col-12">
            <app-textarea-input
              inputId="alternativeCoordinatorDetails"
              label="{{ formConfig['alternativeCoordinatorDetails']?.label }}"
              [control]="
                $any(applicationForm.get('alternativeCoordinatorDetails'))
              "
              [rows]="4"
              [maxLength]="2000"
              placeholder="{{
                formConfig['alternativeCoordinatorDetails']?.infoText
              }}"
            >
            </app-textarea-input>
          </div>

          <!-- 9. Preferred month/fortnight to host the workshop (goes to Part C) -->
          <div class="col-12">
            <app-textarea-input
              inputId="preferredWorkshopTimeline"
              label="{{ formConfig['preferredWorkshopTimeline']?.label }}"
              [control]="
                $any(applicationForm.get('preferredWorkshopTimeline'))
              "
              [rows]="3"
              [maxLength]="300"
              placeholder="{{
                formConfig['preferredWorkshopTimeline']?.infoText
              }}"
            >
            </app-textarea-input>
          </div>
        </div>
      </div>
      <!-- End Part C -->

      <!-- =================== Alternate SPOC =================== -->
      <div class="part-box mb-4 border rounded p-6">
        <h3 class="part-title">Alternate SPOC (if applicable)</h3>

        <div class="row g-3">
          <!-- 1. Alternate SPOC Name & Email -->
          <div class="col-md-6">
            <app-text-input
              inputId="alternateSPOCName"
              label="{{ formConfig['alternateSPOCName']?.label }}"
              placeholder="{{ formConfig['alternateSPOCName']?.placeholder }}"
              [control]="$any(applicationForm.get('alternateSPOCName'))"
              [noteText]="formConfig['alternateSPOCName']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <div class="col-md-6">
            <app-text-input
              inputId="alternateSPOCEmail"
              label="{{ formConfig['alternateSPOCEmail']?.label }}"
              type="email"
              placeholder="{{ formConfig['alternateSPOCEmail']?.placeholder }}"
              [control]="$any(applicationForm.get('alternateSPOCEmail'))"
              [noteText]="formConfig['alternateSPOCEmail']?.infoText || ''"
            >
            </app-text-input>
          </div>

          <!-- 2. Alternate SPOC Designation & Phone -->
          <div class="col-md-6">
            <app-text-input
              inputId="alternateSPOCDesignation"
              label="{{ formConfig['alternateSPOCDesignation']?.label }}"
              placeholder="{{
                formConfig['alternateSPOCDesignation']?.placeholder
              }}"
              [control]="$any(applicationForm.get('alternateSPOCDesignation'))"
              [noteText]="
                formConfig['alternateSPOCDesignation']?.infoText || ''
              "
            >
            </app-text-input>
          </div>

          <div class="col-md-6">
            <app-text-input
              inputId="alternateSPOCPhone"
              label="{{ formConfig['alternateSPOCPhone']?.label }}"
              type="tel"
              inputmode="tel"
              placeholder="{{ formConfig['alternateSPOCPhone']?.placeholder }}"
              [control]="$any(applicationForm.get('alternateSPOCPhone'))"
              [noteText]="formConfig['alternateSPOCPhone']?.infoText || ''"
            >
            </app-text-input>
          </div>
        </div>
      </div>
      <!-- End Alternate SPOC Box -->
      <!-- =================== FurtherDetails =================== -->
      <div class="part-box mb-4 border rounded p-6">
        <h3 class="part-title col-12">Further Details</h3>
        <div class="row g-3">
          <!-- 3. Student Convening Mechanisms -->
          <div class="col-12">
            <app-textarea-input
              inputId="studentConveningMechanisms"
              label="{{ formConfig['studentConveningMechanisms']?.label }}"
              placeholder="{{
                formConfig['studentConveningMechanisms']?.infoText
              }}"
              [maxLength]="2000"
              [rows]="4"
              [control]="
                $any(applicationForm.get('studentConveningMechanisms'))
              "
            >
            </app-textarea-input>
          </div>

          <!-- 4. Preferred Availability Window -->
          <div class="col-md-6">
            <app-date-input
              inputId="preferredAvailabilityFrom"
              label="{{ formConfig['preferredAvailabilityFrom']?.label }}"
              [isRequired]="true"
              [minDate]="minFromDate"
              [control]="$any(applicationForm.get('preferredAvailabilityFrom'))"
            >
            </app-date-input>
            <div
              class="text-danger text-xs mt-1"
              *ngIf="isInvalid('preferredAvailabilityFrom')"
            >
              {{ formConfig["preferredAvailabilityFrom"]?.errorMsg }}
            </div>
          </div>

          <div class="col-md-6">
            <app-date-input
              inputId="preferredAvailabilityTo"
              label="{{ formConfig['preferredAvailabilityTo']?.label }}"
              [isRequired]="true"
              [minDate]="minToDate"
              [control]="$any(applicationForm.get('preferredAvailabilityTo'))"
            >
            </app-date-input>
          </div>

          <!-- 5. Event Alignment Note -->
          <div class="col-12">
            <app-textarea-input
              inputId="eventAlignmentNote"
              label="{{ formConfig['eventAlignmentNote']?.label }}"
              [rows]="4"
              [maxLength]="2000"
              [control]="$any(applicationForm.get('eventAlignmentNote'))"
              placeholder="{{ formConfig['eventAlignmentNote']?.infoText }}"
            >
            </app-textarea-input>
          </div>

          <!-- 6. Bottom Split Grid -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label fw-medium mb-0">
                {{ formConfig["expectedStudentParticipants"]?.label }}
                <span class="text-danger">*</span>
              </label>
              <select
                formControlName="expectedStudentParticipants"
                class="form-select py-2 mt-2"
                style="
                  height: 54px;
                  min-height: 54px;
                  border: 1px solid #d1cfcf;
                  border-radius: 12px;
                "
                [style.fontSize]="
                  applicationForm.get('expectedStudentParticipants')?.value
                    ? '14px'
                    : '15px'
                "
                [style.color]="
                  applicationForm.get('expectedStudentParticipants')?.value
                    ? '#212529'
                    : '#6c757d'
                "
              >
                <option value="" disabled selected hidden>
                  {{ formConfig["expectedStudentParticipants"]?.placeholder }}
                </option>
                <option
                  *ngFor="let count of studentParticipants"
                  [value]="count"
                  style="font-size: 14px; color: #212529"
                >
                  {{ count }}
                </option>
              </select>
              <div
                class="text-danger text-xs mt-1"
                *ngIf="isInvalid('expectedStudentParticipants')"
              >
                {{ formConfig["expectedStudentParticipants"]?.errorMsg }}
              </div>
            </div>
          </div>

          <!-- 7. Additional Information -->
          <div class="col-md-6">
            <app-textarea-input
              inputId="additionalInformation"
              label="{{ formConfig['additionalInformation']?.label }}"
              placeholder="{{ formConfig['additionalInformation']?.infoText }}"
              [control]="$any(applicationForm.get('additionalInformation'))"
              [maxLength]="2000"
            >
            </app-textarea-input>
            <div
              class="text-danger text-xs mt-1"
              *ngIf="isInvalid('additionalInformation')"
            >
              {{ formConfig["additionalInformation"]?.errorMsg }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Form Action Control Row -->
    <div class="d-flex justify-content-between align-items-center my-4 m-4">
      <!-- Cancel Button -->
      <button
        type="button"
        class="btn border border-secondary text-secondary px-4 py-2"
        (click)="handleModalClose()"
      >
        Cancel
      </button>

      <!-- Submit Button -->
      <button
        type="submit"
        class="btn btn-dark px-4 py-2"
        [disabled]="applicationForm.invalid"
      >
        Submit
      </button>
    </div>

    <!-- Inquiries Footer -->
    <div class="mt-5 mb-3">
      <app-support></app-support>
    </div>
  </form>

  <!-- Success Modal -->
  <app-workshop-success-modal
    [isVisible]="showSuccessPopup"
    [referenceId]="generatedReferenceId"
    [userEmail]="submittedUserEmail"
    (closeModal)="handleModalClose()"
  >
  </app-workshop-success-modal>
</div>
}